module.exports = __webpack_public_path__ + "static/media/27.91b76c6b.png";